<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input v-model="tax.label" label="Label" v-uppercase />
          <base-input v-model="tax.rate" label="Rate" />
          <base-input v-model="code" label="Code" />
        </div>
      </div>
      <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Form.name]: Form
  },
  data: () => {
    return {};
  },
  computed: {
    ...mapState("tax", ["tax"]),
    //...mapGetters({tax:'tax/getTax'}),
    code: {
      get() {
        return this.tax.label
          .split(" ")
          .join("_")
          .toLowerCase();
      },
      set(value) {
        return value;
      }
    }
  },

  methods: {
    ...mapActions({
      saveTax: "tax/saveTax",
      updateTax: "tax/updateTax",
      getTaxes: "tax/getTaxes"
    }),
    onSubmit() {
      if (this.tax.taxId) {
        this.tax.code = this.code;
        this.updateTax().then(res => {
          this.$notify({
            message: "Tax Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.$emit("close");
          this.getTaxes();
        });
      } else {
        this.tax.code = this.code;
        this.saveTax().then(res => {
          this.$notify({
            message: "Tax  Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.$emit("close");
          this.getTaxes();
        });
      }
    }
  }
};
</script>

